import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $client_ids: [Int]!){
  removeProjectClients(project_id: $project_id, client_ids: $client_ids){
    ${projectFragment}
  }
}`